import { render, staticRenderFns } from "./copyForms.vue?vue&type=template&id=0e6b3ad1&scoped=true&"
import script from "./copyForms.vue?vue&type=script&lang=js&"
export * from "./copyForms.vue?vue&type=script&lang=js&"
import style0 from "./copyForms.vue?vue&type=style&index=0&id=0e6b3ad1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6b3ad1",
  null
  
)

export default component.exports